import { render } from "./AsideContent.vue?vue&type=template&id=e0a8c9ee"
import script from "./AsideContent.vue?vue&type=script&lang=js"
export * from "./AsideContent.vue?vue&type=script&lang=js"
script.render = render

export default script